
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.001 5.834a4.167 4.167 0 11-8.333 0 4.167 4.167 0 018.333 0zM9.11 10.66a5.833 5.833 0 111.235-1.129l4.386 4.02a.833.833 0 01-1.126 1.229l-4.495-4.12z","fill":"currentColor"}})])
          )
        }
      }
    